/**
 * @desc 订单明细导入
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(
  body: string,
  params: API.business.customerOrder.importSku.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/customerOrder/importSku`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
